import { getI18n } from '@/core/i18n';

const i18n = getI18n();

const crumbs = [
    { label: i18n.t('misc.screen'), route: { name: 'screen$screen' } },
    { label: i18n.t('misc.add_videoset'), route: { name: 'screen$create' } },
    { label: i18n.t('misc.add_episode'), route: { name: 'screen$create' } }, 
    { label: i18n.t('misc.add_videoset'), route: { name: 'screen$detail' } },
    { label: i18n.t('misc.add_episode'), route: { name: 'screen$detail' } },  
    { label: '' }
]

export default [
    {
        path: '/screen',
        name: 'screen$screen',
        component: () => import('@/apps/screen/views/List.vue'),
        meta: { breadCrumb: [crumbs[0]] },
    },
    {
        path: '/screen/create',
        name: 'screen$create',
        component: () => import('@/apps/screen/views/Create.vue'),
        meta: { breadCrumb: [crumbs[0]
            , crumbs[1], crumbs[2], crumbs[5]
        ] },
    },
    {
        path: '/screen/:uuid',
        name: 'screen$detail',
        component: () => import('@/apps/screen/views/Update.vue'),
        meta: { breadCrumb: [crumbs[0]
            , crumbs[3], crumbs[4], crumbs[5]
        ] },
    },
];
